module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pordermanagement"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowOrderList),
      expression: "isShowOrderList"
    }]
  }, [_c('div', {
    staticStyle: {
      "height": ".3rem"
    }
  }), _vm._v(" "), _vm._l((_vm.getOrserList), function(item) {
    return _c('div', {
      staticClass: "order"
    }, [_c('ul', {
      staticClass: "order-title"
    }, [_c('li', [_c('b', [_vm._v("订单号 ：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.ordernumber) + "5")])]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(item.zfzt) + "\n                    ")])]), _vm._v(" "), _c('ul', {
      staticClass: "order-center"
    }, [_c('li', [_c('b', [_vm._v("订单日期 ：")]), _c('span', [_vm._v(_vm._s(item.createtime))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("姓名 ：")]), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("套餐类型 ：")]), _c('span', [_vm._v(_vm._s(item.tc))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("检测状态 ：")]), _c('span', [_vm._v(_vm._s(item.cpzt))])])]), _vm._v(" "), _c('div', {
      staticClass: "order-footer"
    }, [_c('span', [_vm._v("\n                        ¥" + _vm._s(item.tcprice) + "\n                    ")]), _vm._v(" "), (item.zfzt === '已取消') ? _c('button', {
      staticClass: "button-cancel",
      on: {
        "click": _vm.buttonCancel
      }
    }, [_vm._v("再次购买")]) : _vm._e(), _vm._v(" "), (item.zfzt === '未支付') ? _c('button', {
      staticClass: "button-noOrder",
      on: {
        "click": function($event) {
          _vm.buttonOrder(item.ordernumber)
        }
      }
    }, [_vm._v("继续支付")]) : _vm._e(), _vm._v(" "), (item.zfzt === '已支付' && item.cpzt === '已检测') ? _c('button', {
      staticClass: "button-order"
    }, [_vm._v("查看报告")]) : _vm._e(), _vm._v(" "), (item.zfzt === '已支付' && item.cpzt === '未检测') ? _c('button', {
      staticClass: "button-evaluation"
    }, [_vm._v("前往检测")]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".7rem"
    }
  })], 2), _vm._v(" "), _c('myheader', {
    ref: "pheader"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNull),
      expression: "isShowNull"
    }],
    staticClass: "order-null"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Group.png")
    }
  }), _vm._v(" "), _c('h5', [_vm._v("\n                暂无订单\n            ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356ca517","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/phonecomponents/ordermanagement.vue
// module id = 751
// module chunks = 1